module.exports = __webpack_public_path__ + "static/img/govcard_03.242e2e43.svg";